import { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'

function Swiping({ children }) {
  const swiperRef = useRef(null)
  useEffect(() => swiperRef.current.swiper.slideTo(1, 1000))
  return (
    <Swiper pagination={true} ref={swiperRef}>
      {children.map(child => <SwiperSlide>{child}</SwiperSlide>)}
    </Swiper>
  )
}

export default Swiping